import _styled from "styled-components";
const _excluded = ["children", "style", "tableSize"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
import { TABLE_SIZES } from '../consts';
import getTableTheme from '../helpers/getTableTheme';
const TableHeaderGroup = _ref => {
  let {
      children,
      style = {},
      tableSize
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const tableSizeTheme = getTableTheme(tableSize);
  return /*#__PURE__*/React.createElement(_StyledTr, _extends({}, props, {
    $_css: [{
      width: '100%',
      minWidth: 'fit-content',
      position: 'relative',
      display: 'flex',
      height: tableSizeTheme.rowHeight
    }, style]
  }), children);
};
TableHeaderGroup.propTypes = {
  tableSize: PropTypes.oneOf(Object.values(TABLE_SIZES)),
  style: stylePropType,
  children: PropTypes.any
};
export default TableHeaderGroup;
var _StyledTr = _styled("tr").withConfig({
  displayName: "TableHeaderGroup___StyledTr",
  componentId: "sc-kuqxs0-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=TableHeaderGroup.js.map